<template>
    <div class="w-full">
        <div class="rounded-lg min-h-[850px] bg-white">
            <div class="px-20 pt-10">
                <h2 class="text-gray-700 text-2xl underline">Veuillez validé le document</h2>
            </div>
            <div class="mx-auto w-[70%] rounded-lg px-7 py-8 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th></th>
                            <th class="text-2xl text-black font-normal">REQUEST FOR CERTIFICATE</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal w-1/3">Name: {{ nom ?? "" }}</th>
                            <th class="text-2xl text-black font-normal">Job title: {{ job }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th class="text-2xl text-black font-normal">Type of Certificate(s)</th>
                            <th class="text-2xl text-black font-normal">{{ type }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">Language (s)</th>
                            <th class="text-2xl text-black font-normal">{{ langage }}</th>
                        </tr>
                        <tr>
                            <th class="text-2xl text-black font-normal">Purpose</th>
                            <th class="text-2xl text-black font-normal">{{ purpose }}</th>
                        </tr>
                    </tbody>
                </table>
                <div class="mt-14 text-gray-700 mb-4 flex">
                    <p class="w-[60%]">
                        Employee’s signature:
                    </p>
                    <div class="w-[300px] h-[150px] rounded-xl border border-dashed mt-5 flex flex-col items-center justify-center p-3">
                            <p v-if="!signature" class="font-extralight text-black">Pas de signature</p>
                            <img v-else :src="getPath" :alt="signature" class="h-full object-contain">
                        </div>
                    <p>
                        Date:
                    </p>
                </div>
                <div class="mt-80">
                    <table class="table table-bordered">
                        <tbody>
                            <tr>
                                <th class="text-black font-normal text-sm"><span class="font-bold">Type of certificate</span>: Employment certificate, Leave Certificate and Salary Certificate<br>
                                    PS: For <span class="font-bold">leave certificate</span>, a request for leave form must be first completed.</th>
                            </tr>
                            <tr>
                                <th class="text-black font-normal text-sm"><span class="font-bold">Language</span>: English, French or both.</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="inline-flex gap-x-3 justify-center w-full mt-48">
                <button v-on:click="saveForm" class="h-14 w-32 bg-[#5357ec] text-white rounded-lg text-xl font-semibold hover:bg-[#4349d1] transition-all duration-300">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto text-white"/>
                    <span v-if="!asSend">Valider</span>
                </button>
                <button class="h-14 w-32 bg-[#f44336] text-white rounded-lg text-xl font-semibold hover:bg-[#d32f2f] transition-all duration-300">
                    Refuser
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "RequestForCertValid",
    components: {Loader2},
    data() {
        return {
            id: "",
            asSend: false,
            nom: null,
            job: null,
            type: null,
            langage: null,
            purpose: null,
            signature: null
        };
    },
    created(){
        this.id = this.$route.params.id;
    },
    mounted() {
        this.getOneUserDocDemande();
        this.signature = localStorage.getItem("signature") ?? undefined;
    },
    computed:{
        getPath(){
            return `https://backend-ehr.iugb-ci.com/public/image/${this.signature}`;
        }
    },
    methods: {
        getOneUserDocDemande(){
            API.get("/user-docs/"+this.id)
            .then((data)=>{
                if(data.data["status"] == 'success'){
                    this.nom= JSON.parse(data.data["data"]["content"]).nom;
                    this.job= JSON.parse(data.data["data"]["content"]).job
                    this.type= JSON.parse(data.data["data"]["content"]).type
                    this.langage= JSON.parse(data.data["data"]["content"]).langage
                    this.purpose= JSON.parse(data.data["data"]["content"]).purpose
                }
            })
            .catch(e=>{console.log(e)})
        },
        saveForm(){
            this.asSend = true;
            if(!this.signature){
                toast.error("Erreur","Veuillez enregistré votre signature à partie de votre profile",5000);
                return;
            }
            const data = {
                "validation_rh" : 1,
                "validator_id" : localStorage.getItem("userId"),
                "validator_sign" : this.signature
            }
            API.put("user-docs/"+this.id, data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000);
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>